import { OktaAuth } from '@okta/okta-auth-js';
import { oktaAuthConfig } from './config';

export const oktaAuth = new OktaAuth(oktaAuthConfig);
